import { Link } from "react-router-dom";
import { LANDING } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer data-testid={LANDING.footer} className="bg-white border-t border-slate-200">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="flex items-start justify-between flex-wrap gap-10">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-[#0f172a] text-white font-display font-bold text-sm">C</span>
              <span className="font-display font-semibold text-[17px] tracking-tighter text-slate-900">
                coachly<span className="text-[#10B981]">.</span>
              </span>
            </div>
            <p className="mt-5 text-[13.5px] text-slate-600 leading-relaxed">
              The marketplace for trusted independent coaches. Sports, skills and personal growth — one app.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-10 text-[13.5px] text-slate-600">
            <div>
              <div className="eyebrow mb-3">Product</div>
              <ul className="space-y-2">
                <li><a href="/#how-it-works" className="hover-underline">How it works</a></li>
                <li><a href="/#features" className="hover-underline">Features</a></li>
                <li><a href="/marketplace" className="hover-underline">Marketplace</a></li>
              </ul>
            </div>
            <div>
              <div className="eyebrow mb-3">Company</div>
              <ul className="space-y-2">
                <li><a href="/#final" className="hover-underline">Join the waitlist</a></li>
                <li><a href="/apply" className="hover-underline">Become a coach</a></li>
                <li><a href="mailto:hello@coachly.app" className="hover-underline">hello@coachly.app</a></li>
              </ul>
            </div>
            <div>
              <div className="eyebrow mb-3">Policies</div>
              <ul className="space-y-2">
                <li><Link to="/terms" data-testid="footer-link-terms" className="hover-underline">Terms of Service</Link></li>
                <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover-underline">Privacy Policy</Link></li>
                <li><Link to="/refund-policy" data-testid="footer-link-refunds" className="hover-underline">Refund &amp; Cancellations</Link></li>
              </ul>
            </div>
            <div>
              <div className="eyebrow mb-3">Community</div>
              <ul className="space-y-2">
                <li><Link to="/coach-guidelines" data-testid="footer-link-coach-guidelines" className="hover-underline">Coach Guidelines</Link></li>
                <li><Link to="/trust-safety" data-testid="footer-link-trust-safety" className="hover-underline">Trust &amp; Safety</Link></li>
                <li><a href="mailto:safety@coachly.app" className="hover-underline">Report an issue</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-200 flex items-center justify-between flex-wrap gap-4 text-[12px] text-slate-500">
          <div>© {new Date().getFullYear()} Coachly, Inc. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Made for coaches &amp; clients in the US.</span>
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />
              System operational
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
